/* eslint-disable indent */
import axios from 'axios'

let api = {
    methods: {
        api () {
            let headers = {'Content-Type': 'application/json'}
            let userData = this.getUserData()

            if (userData) {
                headers = {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + userData['access_token']
                }
            }

            return axios.create({
                baseURL: process.env.SERVICE_URL,
                headers: headers
            })
        }
    }
};

export default api



// WEBPACK FOOTER //
// ./src/mixins/webservice.js